import React, { useState, useEffect } from 'react';
import {
    Modal,
    Box,
    TextField,
    Button,
    Select,
    MenuItem,
    Typography,
    List,
    ListItem,
    ListItemText,
    ListItemButton,
    IconButton
} from '@mui/material';
import {
    getSlides,
    getTopSlides, addSlideToTop, deleteTopSlide, duplicateTopSlide, reorderTopSlides
} from '../services/api';
import {Slide, Top, TopSlide, TopEdit} from "../services/types";
import {Add, ArrowLeft, ArrowRight, Delete} from "@mui/icons-material";

interface SlideImage {
    id: string;
    url: string;
}
interface TopEditModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSaveTop: (topdData: TopEdit | null, topSlides: SlideImage[]) => void;
    top: string;
    slideId: string;
    projectId: string;
}

function moveIdBack(items: SlideImage[], targetId: string): string[] {
    const index = items.findIndex(item => item.id === targetId);
    if (index <= 0) {
        return items.map(item => item.id);
    }
    const newItems = [...items];
    [newItems[index - 1], newItems[index]] = [newItems[index], newItems[index - 1]];
    return newItems.map(item => item.id);
}
function moveIdForwards(items: SlideImage[], targetId: string): string[] {
    const index = items.findIndex(item => item.id === targetId);
    // Если элемент не найден или это последний элемент — ничего не делаем
    if (index === -1 || index >= items.length - 1) {
        return items.map(item => item.id);
    }
    const newItems = [...items];
    // Меняем местами текущий элемент и следующий
    [newItems[index], newItems[index + 1]] = [newItems[index + 1], newItems[index]];
    return newItems.map(item => item.id);
}

const TopEditModal: React.FC<TopEditModalProps> = ({ isOpen, onClose, onSaveTop, top, slideId, projectId }) => {
    const [slides, setSlides] = useState<Slide[]>([]);
    const [topSlides, setTopSlides] = useState<TopSlide[]>([]);
    const [files, setFiles] = useState([]);
    const [selectedItem, setSelectedItem] = useState('');
    const [siteUrl, setSiteUrl] = useState('');
    const [isSlideSelectionModalOpen, setIsSlideSelectionModalOpen] = useState(false);
    const [isDuplicateModalOpen, setIsDuplicateModalOpen] = useState(false);
    const [slidesImages, setSlidesImages] = useState<SlideImage[]>([]);

    console.log(top)

    const fetchSlides = async () => {
        try {
            const response = await getSlides(projectId);
            setSlides(response.items);
        } catch (error) {
            console.error('Error fetching slides:', error);
        }
    };

    const fetchTopSlides = async () => {
        try {
            const response = await getTopSlides(top);
            setTopSlides(response);
        } catch (error) {
            console.error('Error fetching slides:', error);
        }
    };
    useState(() => {
        fetchSlides()
    });

    useState(() => {
        fetchTopSlides()
    });



    const handleSave = async () => {
    };
    const handleSlideImages = async (slidesImage: string, slideId: string) => {
        var imagesList = slidesImages
        imagesList.push({ url: slidesImage, id: slideId})
        setSlidesImages(imagesList)
        setIsSlideSelectionModalOpen(false)

        const topDataVal = {
            parent_id: top,
            slide_id: slideId as string
        };
        await addSlideToTop(topDataVal);
        fetchTopSlides()

    }
    const handleDelete = async (topId: TopSlide) => {
        await deleteTopSlide(topId.id);
        fetchTopSlides()
    }

    const handleDuplicate = async () => {
        setIsDuplicateModalOpen(true);
    }

    const onConfirm = async () => {
        await duplicateTopSlide(projectId, top);
        setIsDuplicateModalOpen(false);
    }

    const handleAddSlideToTop = async (slideId: string) => {
        setIsSlideSelectionModalOpen(false);
        const topDataVal = {
            parent_id: top,
            slide_id: slideId as string,
            sort: topSlides.length
        };
        await addSlideToTop(topDataVal);
        fetchTopSlides()
    };

    const handlePrev = async (slideIdStr: string) => {
        const list: string[] = moveIdBack(topSlides, slideIdStr)
        await reorderTopSlides(slideId, list);
        fetchTopSlides()

    }
    const handleNext = async (slideIdStr: string) => {
        const list: string[] = moveIdForwards(topSlides, slideIdStr)
        await reorderTopSlides(slideId, list);
        fetchTopSlides()
    }

    return (
        <>
            <Modal open={isOpen} onClose={()=>onClose()}>
                <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, minWidth: 600 }}>
                    <Typography variant="h6" component="h2" gutterBottom>
                        Слайды для свайпа сверху
                    </Typography>

                    <Box>
                        <List sx={{display:'flex', flexWrap:'wrap', gap: 1}}>
                            {topSlides.map((slideitem) => (
                                <Box className='addModalSlideItem' key={slideitem.id}
                                     sx={{
                                         position: 'relative',
                                         '&:hover .deleteButton': {opacity: 1},
                                         '&:hover .prevButton': {opacity: 1},
                                         '&:hover .nextButton': {opacity: 1}
                                     }}>
                                    <img src={slideitem.slide.preview}/>
                                    {topSlides.length > 1 && (
                                        <>
                                            <IconButton
                                                className="prevButton"
                                                sx={{
                                                    position: 'absolute',
                                                    top: 5,
                                                    left: 5,
                                                    opacity: 0,
                                                    transition: 'opacity 0.2s',
                                                    color: '#fff',
                                                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                                                    '&:hover': {backgroundColor: 'rgba(0, 0, 0, 0.9)'}
                                                }}
                                                onMouseDown={(e) => e.stopPropagation()}
                                                onMouseUp={(e) => {e.stopPropagation(); handlePrev(slideitem.id);}}
                                                // onClick={handleDelete}
                                            >
                                                <ArrowLeft/>
                                            </IconButton>
                                            <IconButton
                                                className="nextButton"
                                                sx={{
                                                    position: 'absolute',
                                                    top: 5,
                                                    left: 50,
                                                    opacity: 0,
                                                    color: '#fff',
                                                    transition: 'opacity 0.2s',
                                                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                                                    '&:hover': {backgroundColor: 'rgba(0, 0, 0, 0.9)'}
                                                }}
                                                onMouseDown={(e) => e.stopPropagation()}
                                                onMouseUp={(e) => {e.stopPropagation(); handleNext(slideitem.id);}}
                                                // onClick={handleDelete}
                                            >
                                                <ArrowRight/>
                                            </IconButton>
                                        </>
                                    )}
                                    <IconButton
                                        className="deleteButton"
                                        sx={{
                                            position: 'absolute',
                                            top: 5,
                                            right: 5,
                                            opacity: 0,
                                            transition: 'opacity 0.2s',
                                            backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                            '&:hover': {backgroundColor: 'rgba(255, 255, 255, 0.9)'}
                                        }}
                                        onMouseDown={(e) => e.stopPropagation()}
                                        onMouseUp={(e) => {e.stopPropagation(); handleDelete(slideitem);}}
                                        // onClick={handleDelete}
                                    >
                                        <Delete/>
                                    </IconButton>
                                </Box>
                            ))}
                        </List>

                        <Button onClick={() => {
                            setIsSlideSelectionModalOpen(true)
                        }}>
                            <ListItemText primary="Add new slide" />
                        </Button>
                    </Box>

                    <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                        <Button onClick={()=>handleDuplicate()} sx={{ mr: 1 }}>
                            <Add/> Установить всем слайдам
                        </Button>
                        <Button onClick={()=>onClose()} sx={{ mr: 1 }}>Закрыть</Button>
                        {/*<Button onClick={() => handleSave()} variant="contained">Save</Button>*/}
                    </Box>
                </Box>
            </Modal>
            {/* Модальное окно выбора слайда */}
            <Modal open={isSlideSelectionModalOpen} onClose={() => setIsSlideSelectionModalOpen(false)}>
                <Box sx={{flexGrow:1, minHeight: '100vh', display: 'flex', justifyContent:'center', alignItems:'center'}}>
                    <Box className="modalFiled" sx={{ position: 'relative', bgcolor: 'background.paper', boxShadow: 24, maxWidth: 960, minWidth: 300, maxHeight:'90vh', overflow: 'scroll' }}>
                        <Box className='addModalSlideItems'>
                            {slides.map((slide) => (
                                <Box className='addModalSlideItem' key={slide.id} onClick={()=>handleAddSlideToTop(slide.id)}>
                                    <img src={slide.preview} alt={slide.name}/>
                                </Box>
                            ))}
                        </Box>
                        <Box sx={{display:'flex', justifyContent: 'space-between', mt: 2, gap: 2}}>
                            <Box></Box>
                            <Button className="blueModalButton" variant="outlined" onClick={()=>setIsSlideSelectionModalOpen(false)} style={{color: 'red', borderColor: 'red'}}>
                                Отмена
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>

            <Modal open={isDuplicateModalOpen}>
                <Box sx={{flexGrow:1, minHeight: '100vh', display: 'flex', justifyContent:'center', alignItems:'center'}}>
                    <Box className="modalFiled" sx={{ position: 'relative', bgcolor: 'background.paper', boxShadow: 24 }}>
                        <Typography variant="h6" component="h2" gutterBottom>
                            Вы уверены, что хотите применить ко всем слайдам?
                        </Typography>
                        <Box sx={{display:'flex', justifyContent: 'space-between', mt: 2, gap: 2}}>
                            <Button className="blueModalButton" variant="contained" onClick={onConfirm}>
                                Применить
                            </Button>
                            <Button className="blueModalButton" variant="outlined" onClick={() => setIsDuplicateModalOpen(false)} style={{color: 'red', borderColor: 'red'}}>
                                Отмена
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>
        </>


    );
};

export default TopEditModal;
